import { render } from "./RoundedSquareButton.vue?vue&type=template&id=e5c6a6a0"
import script from "./RoundedSquareButton.vue?vue&type=script&lang=js"
export * from "./RoundedSquareButton.vue?vue&type=script&lang=js"

import "./RoundedSquareButton.vue?vue&type=style&index=0&id=e5c6a6a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__